import { render } from "./AlertConfigTable.vue?vue&type=template&id=b4df1e00&scoped=true"
import script from "./AlertConfigTable.vue?vue&type=script&lang=js"
export * from "./AlertConfigTable.vue?vue&type=script&lang=js"

import "./AlertConfigTable.vue?vue&type=style&index=0&id=b4df1e00&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4df1e00"]])

export default __exports__